<div class="cart-clear-button-container"
     [matTooltip]="'CART.DELETE_CART' | transloco">
  <button type="button"
          mat-icon-button
          (click)="onClearCart()">
    <mat-icon>remove_shopping_cart</mat-icon>
  </button>
</div>
